import React, { useState, lazy } from 'react';
const reviews = [{
  avatar: 'https://cdn.magicpatterns.com/uploads/bRDorQNi966SU2uTALtBSs/Disen-o-sin-ti-tulo-(41).png',
  name: 'Carlos M.',
  stars: 5,
  title: '¡Increíble material, todo muy claro!',
  date: 'Calificado en México el 15 de abril de 2026',
  format: 'PDF Digital',
  verified: true,
  text: 'Todo está explicado paso a paso. No tenía experiencia y ya estoy haciendo mis primeras instalaciones. Los diagramas son muy claros y fáciles de seguir. Vale totalmente la pena, lo recomiendo a cualquier persona que quiera aprender comandos eléctricos desde cero.',
  helpful: 24,
  translated: true
}, {
  avatar: 'https://cdn.magicpatterns.com/uploads/pK6zp7AMwMqLxumx5zQYM1/fee6b92aff3d1bb23295eb0cc23a173c-(1).jpg',
  name: 'Luis R.',
  stars: 5,
  title: 'De principiante a conseguir trabajos reales',
  date: 'Calificado en Colombia el 8 de marzo de 2026',
  format: 'PDF Digital',
  verified: true,
  text: 'No sabía nada de electricidad… ahora incluso estoy consiguiendo trabajos. Muy fácil de entender y aplicar. El simulador que viene como bono es excelente para practicar antes de ir a un trabajo real. Sin duda la mejor inversión que he hecho este año.',
  helpful: 11,
  translated: false
}];
function AmazonStars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-[0.5px]" data-id="element-13">
      {Array.from({
      length: 5
    }).map((_, i) => <svg key={i} viewBox="0 0 24 24" className="w-[16px] h-[16px]" fill={i < count ? '#FFA41C' : '#E0E0E0'} data-id="element-14">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-15" />
        </svg>)}
    </div>;
}
export function AmazonReviewsSection() {
  const [expandedReviews, setExpandedReviews] = useState<Set<number>>(new Set());
  const toggleExpand = (index: number) => {
    setExpandedReviews(prev => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);else next.add(index);
      return next;
    });
  };
  return <section className="py-4 px-0 bg-white" data-id="element-16">
      <div className="max-w-2xl mx-auto" data-id="element-17">
        {/* Amazon-style tab header */}
        <div className="border-b border-[#e5e5e5] mb-4 px-4" data-id="element-18">
          <div className="flex gap-6" data-id="element-19">
            <span className="text-[14px] text-[#565959] pb-2 cursor-pointer hover:text-[#c45500]" data-id="element-20">
              Principal
            </span>
            <span className="text-[14px] text-[#565959] pb-2 cursor-pointer hover:text-[#c45500]" data-id="element-21">
              Acerca de este producto
            </span>
            <span className="text-[14px] text-[#c45500] font-medium pb-2 border-b-2 border-[#e77600] cursor-pointer" data-id="element-22">
              Opiniones
            </span>
          </div>
        </div>

        {/* Section title */}
        <div className="px-4 mb-3" data-id="element-23">
          <h3 className="text-[18px] font-bold text-[#0F1111] font-[Arial,_sans-serif]" data-id="element-24">
            Opiniones de clientes
          </h3>
          <div className="flex items-center gap-2 mt-1" data-id="element-25">
            <AmazonStars count={5} data-id="element-26" />
            <span className="text-[14px] text-[#0F1111]" data-id="element-27">4.9 de 5</span>
          </div>
          <p className="text-[13px] text-[#565959] mt-0.5" data-id="element-28">
            12,349 calificaciones globales
          </p>
        </div>

        {/* Reviews */}
        <div className="divide-y divide-[#e5e5e5]" data-id="element-29">
          {reviews.map((review, index) => {
          const isExpanded = expandedReviews.has(index);
          const needsTruncation = review.text.length > 150;
          return <div key={index} className="px-4 py-4" data-id="element-30">
                {/* Translated notice */}
                {review.translated && <div className="mb-3" data-id="element-31">
                    <p className="text-[13px] text-[#565959]" data-id="element-32">
                      Traducido del idioma Inglés por Amz
                    </p>
                    <div className="flex items-center gap-1.5 mt-0.5" data-id="element-33">
                      <a href="#" className="text-[13px] text-[#007185] hover:text-[#c45500] hover:underline" data-id="element-34">
                        Ver el original
                      </a>
                      <span className="text-[13px] text-[#565959]" data-id="element-35">·</span>
                      <a href="#" className="text-[13px] text-[#007185] hover:text-[#c45500] hover:underline" data-id="element-36">
                        Informar traducción incorrecta
                      </a>
                    </div>
                  </div>}

                {/* Avatar + Name */}
                <div className="flex items-center gap-2 mb-2" data-id="element-37">
                  <img src={review.avatar} alt={review.name} className="w-[34px] h-[34px] rounded-full object-cover" loading="lazy" data-id="element-38" />
                  <span className="text-[13px] text-[#0F1111] font-medium" data-id="element-39">
                    {review.name}
                  </span>
                </div>

                {/* Stars + Title */}
                <div className="flex items-center gap-2 mb-1" data-id="element-40">
                  <AmazonStars count={review.stars} data-id="element-41" />
                  <span className="text-[14px] font-bold text-[#0F1111]" data-id="element-42">
                    {review.title}
                  </span>
                </div>

                {/* Date */}
                <p className="text-[13px] text-[#565959] mb-0.5" data-id="element-43">
                  {review.date}
                </p>

                {/* Format + Verified */}
                <div className="flex items-center gap-2 mb-3" data-id="element-44">
                  <span className="text-[13px] text-[#565959]" data-id="element-45">
                    Formato: {review.format}
                  </span>
                  {review.verified && <>
                      <span className="text-[13px] text-[#565959]" data-id="element-46">|</span>
                      <span className="text-[13px] text-[#c45500] font-semibold" data-id="element-47">
                        Compra Verificada
                      </span>
                    </>}
                </div>

                {/* Review text */}
                <div className="mb-2" data-id="element-48">
                  <p className="text-[14px] text-[#0F1111] leading-[1.6]" data-id="element-49">
                    {needsTruncation && !isExpanded ? review.text.slice(0, 150) + '...' : review.text}
                  </p>
                  {needsTruncation && <button onClick={() => toggleExpand(index)} className="flex items-center gap-1 mt-1 text-[13px] text-[#007185] hover:text-[#c45500] hover:underline cursor-pointer bg-transparent border-none p-0" data-id="element-50">
                      <svg viewBox="0 0 24 24" className={`w-3.5 h-3.5 transition-transform ${isExpanded ? 'rotate-180' : ''}`} fill="currentColor" data-id="element-51">
                        <path d="M7 10l5 5 5-5H7z" data-id="element-52" />
                      </svg>
                      {isExpanded ? 'Leer menos' : 'Leer más'}
                    </button>}
                </div>

                {/* Helpful count */}
                <p className="text-[13px] text-[#565959] mb-2" data-id="element-53">
                  A {review.helpful} personas les resultó útil
                </p>

                {/* Útil + Reportar */}
                <div className="flex items-center gap-3" data-id="element-54">
                  <button className="text-[13px] text-[#0F1111] border border-[#D5D9D9] rounded-lg px-4 py-1.5 bg-[#F0F2F2] hover:bg-[#E3E6E6] cursor-pointer transition-colors shadow-[0_1px_2px_rgba(0,0,0,0.05)]" data-id="element-55">
                    Útil
                  </button>
                  <span className="text-[13px] text-[#D5D9D9]" data-id="element-56">|</span>
                  <button className="text-[13px] text-[#007185] hover:text-[#c45500] hover:underline cursor-pointer bg-transparent border-none p-0" data-id="element-57">
                    Reportar
                  </button>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}